import { gql } from "@apollo/client";
import { ImageFragment } from "../../fragments/image";
import { ResourceBaseFragment } from "../../fragments/resource";

export const QUERY_FETCH_RESOURCES = gql`
  query resources($limit: Int, $page: Int, $type: String, $category: String) {
    resources_connection(
      filters: {
        type: { type: { eq: $type } }
        category: { category: { eq: $category } }
        publishedAt: { notNull: true }
      }
      pagination: { pageSize: $limit, page: $page }
      sort: "publicationDate:desc"
      status: PUBLISHED
    ) {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
          pageSize
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_RESOURCE_BY_SLUG = gql`
  query resourceBySlug($slug: String!) {
    resources_connection(
      filters: { slug: { eq: $slug }, publishedAt: { notNull: true } }
      status: PUBLISHED
    ) {
      data {
        id
        attributes {
          ...ResourceBaseFragment
          DefaultContentTemplate {
            __typename
            ... on ComponentCommonH3 {
              text
            }
            ... on ComponentCommonTitle {
              title
            }
            ... on ComponentCommonAuthor {
              author {
                data {
                  attributes {
                    name
                    role
                  }
                }
              }
              publicationDate
            }
            ... on ComponentCommonDivider {
              id
            }
            ... on ComponentCommonEmbedded {
              link
              provider
            }
            ... on ComponentCommonTextEditor {
              markdownText
            }
            ... on ComponentCommonQuote {
              quote
            }
            ... on ComponentCommonAudio {
              audio {
                data {
                  attributes {
                    url
                    name
                  }
                }
              }
              transcription
            }
            ... on ComponentCommonAuthorDetailed {
              authors: authors_connection {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }
            ... on ComponentResourceAssets {
              assets: assets_connection {
                data {
                  id
                  attributes {
                    title
                    description
                    content {
                      data {
                        attributes {
                          url
                          name
                          ext
                          mime
                          size
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on ComponentResourceResourcesRelated {
              resources: resources_connection {
                data {
                  attributes {
                    title
                    slug
                    cover {
                      data {
                        ...ImageFragment
                      }
                    }
                    type {
                      data {
                        attributes {
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${ResourceBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_LATEST_RESOURCES = gql`
  query latestResources($limit: Int) {
    resources_connection(
      pagination: { pageSize: $limit }
      sort: "publicationDate:desc"
      filters: { publishedAt: { notNull: true } }
      status: PUBLISHED
    ) {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_RESOURCES_BY_TYPE = gql`
  query resourcesByType($type: String!, $limit: Int, $page: Int) {
    resources_connection(
      filters: { type: { type: { eq: $type } }, publishedAt: { notNull: true } }
      pagination: { pageSize: $limit, page: $page }
      sort: "publicationDate:desc"
      status: PUBLISHED
    ) {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
          pageSize
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_RESOURCES_BY_CATEGORY = gql`
  query resourcesByCategory($category: String!, $limit: Int, $page: Int) {
    resources_connection(
      filters: {
        category: { category: { eq: $category } }
        publishedAt: { notNull: true }
      }
      pagination: { pageSize: $limit, page: $page }
      sort: "publicationDate:desc"
      status: PUBLISHED
    ) {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
          pageSize
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;
